import fetchJQueryAdapter from '@/tools/fetchJQueryAdapter';

/**
 * @memberof module:ajaxAPI/favorites
 * @alias remove
 *
 * @description
 * Очистка избранного
 *
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.favorites.clear()
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */

export default function() {
  return fetchJQueryAdapter('/front_api/favorites/clear.json',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    }
  );
}
